import type { BankerContractDto } from '../dto';
import type { BankerContract } from '../models';

export const mapBankerContractToDto = (
  contract: BankerContract,
): BankerContractDto => ({
  ...contract,
  clients: contract.clients ?? [],
});
